import React, { useEffect, useState } from 'react';
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux';
import Input from './UI/Input/Input'
import { define, tokenExpiredMsg, expNotifyDuration } from '../data/globals'
import MyEditor from './UI/MyEditor/MyEditor'
import { useNotify } from '../hooks/useNotify';


const CatFormUpdate = (props) => {
    const updCatStore = useSelector(state => state.updCat)
    const dispath = useDispatch()
    const [isFilled1, setIsFilled1] = useState(false)
    const [isFilled2, setIsFilled2] = useState(false)
    const { pushNotify } = useNotify()


    function inputName(event) {
        dispath({ type: 'SetTypedCName', name: event.target.value })
        // // сняте подсветки, если поле заполнено
        // if(event.target.value.length > 0) setIsFilled1(false);
        // else setIsFilled1(true)
    }
    // // Для простого инпута:
    // function inputDescr(event) {
    //     // dispath({ type: 'SetNewCatDescr', description: event.target.value})
    //     dispath({ type: 'SetTypedCDescr', description: event.target.value })
    //     // // сняте подсветки, если поле заполнено
    //     // if(event.target.value.length > 0) setIsFilled2(false);
    //     // else setIsFilled2(true)
    // }
    // Для tinyMCE редактора:
    function inputDescr(editorText) {
        dispath({ type: 'SetTypedCDescr', description: editorText })
    }

    function checkForm(e) {
        e.preventDefault()
        let pointsToGo = 2
        // подсветка пустых полей
        if(updCatStore.name.length === 0) { setIsFilled1(true); pointsToGo-- }
        if(updCatStore.description.length === 0) { setIsFilled2(true); pointsToGo-- }
        // Поля заполнены - сохраняем категорию
        (pointsToGo === 2) ? updateCategory()
            : pushNotify("Заполните обязательные поля,<br>чтобы сохранить категорию", "notifyRed")
            // : props.pushNotify("Заполните обязательные поля,<br>чтобы сохранить категорию", "notifyRed")
    }

    async function updateCategory() {
    
        try {
            const response = await axios({
                method: 'post',
                url: define.pathToAPI + '/categories/update.php',
                data: JSON.stringify({
                    id: updCatStore.id,
                    name: updCatStore.name,
                    description: updCatStore.description,
                    userToken: localStorage.getItem('AuthToken'),
                }),
            })

            // проверка ответа от update.php
            switch(response.data.message){
                case 'Категория обновлена':
                    props.update()
                    break
                case 'Токен устарел!':
                    pushNotify( tokenExpiredMsg, "notifyWelcome", expNotifyDuration)
                    // props.pushNotify( tokenExpiredMsg, "notifyWelcome", expNotifyDuration)
                    // ########################################################
                    // При блокировке доступа, удалить картинки, которые не были сохранены в базе
                    // ########################################################
                    break
                case 'Токены не совпадают! Доступ запрещен':
                    pushNotify("Токены не совпадают! Alarm! Доступ запрещен", "notifyWelcome")
                    // props.pushNotify("Токены не совпадают! Alarm! Доступ запрещен", "notifyWelcome")
                    // ########################################################
                    // При блокировке доступа, удалить картинки, которые не были сохранены в базе
                    // ########################################################
                    break
                default:
                    console.log('Ошибка при обновлении товара.\nСервер отвечает (код 200). Но нет подтверждения от update.php, что товар обновлен')
                    console.log(response)
                    alert('Ошибка при обновлении товара (см.  консоль)')
                    break
            } // switch

        } catch (e) {
            if(e === 'AxiosError: Request failed with status code 400') {
                console.log('Ошибка при обновлении товара.\nКод: 400 - Некорректный ID\n(см. update.php)')
                alert('Ошибка (код: 400) при обновлении товара (см.  консоль)')
            } else {
                console.log(e)
                alert('Ошибка при обновлении товара\n' + e)
            }
        }// try
        
    }// updateProduct

    useEffect(()=>{
        // подсветка пустого поля
        if(updCatStore.name.length > 0) setIsFilled1(false)
        else setIsFilled1(true)
        // eslint-disable-next-line react-hooks/exhaustive-deps        
    }, [updCatStore.name])

    useEffect(()=>{
        // подсветка пустого поля
        if(updCatStore.description.length > 0) setIsFilled2(false)
        else setIsFilled2(true)
        // eslint-disable-next-line react-hooks/exhaustive-deps        
    }, [updCatStore.description])

    return (
        <div className={ isFilled2 ? 'alarm-on' : 'alarm-off' }>
            <h1>{ props.header }</h1>
            {(updCatStore.id > 0) &&
                <div>
                    ID категории: <b>{ updCatStore.id }</b><br/>
                    <form className="mt-10">
                        Название:<br/>
                        <Input
                            className={`form-input w540 ${(isFilled1) ? "notfilled" : ""}`}
                            value={ updCatStore.name }
                            onChange={ inputName }
                        />
                        <div className="tooltip mb-10">
                        { isFilled1 && <div className="tooltiptext ml-90 mt-7">Заполните название</div> }
                        </div>

                        Описание:<br/>
                        <MyEditor
                            value={ updCatStore.description }
                            onEditorChange={ inputDescr }
                        />
                        <div className="tooltip mb-15">
                        { isFilled2 && <div className="tooltiptext ml-90 mt-m20">Заполните описание</div> }
                        </div>

                        <button onClick={ checkForm } className='btn greenBtn'>Сохранить</button>
                    </form><br/>
                </div>
            }

        </div>
    )
}

export default CatFormUpdate;